import { theme } from '@approvalmax/theme';
import { VideoIcon } from '@approvalmax/ui';
import styled from 'styled-components';

export const StyledVideoIcon = styled(VideoIcon)`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    fill: ${theme.color.midnight80};
    color: transparent;
`;

export const ThumbnailArea = styled.div`
    position: relative;
`;
